import createReactComponent from '../createReactComponent';
export default createReactComponent('annoyed-circle', 'AnnoyedCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9 15.5h6m-5-5.25H9m6 0h-1","key":"svg-0"}]]);